import { useState } from "react";

import Header from "../components/global/Header";
import Footer from "../components/global/Footer";
import { SpinnerPage } from "../components/global/Spinner";
import BlockButton from "../components/chat/BlockButton";
import useBlockedUsers from "../hooks/useBlockedUsers";
import { messages } from "../constants/messages";
import "../components/others/styles/BlockedUsers.scss";

// Issue #126: ブロックしたユーザーの一覧と解除
const BlockedUsers = () => {
  const { users, isLoaded, error, removeUser } = useBlockedUsers();
  // 行が消えると BlockButton 内の完了表示も消えるため、ページ上部で知らせる
  const [statusMessage, setStatusMessage] = useState(null);

  const handleUnblocked = (id) => {
    const user = users.find((u) => u.id === id);
    removeUser(id);
    setStatusMessage(messages.unblockedUser(user?.name || ""));
  };

  const renderContent = () => {
    if (!isLoaded) return <SpinnerPage />;
    if (error) return <p className="blocked-users__error">{error}</p>;
    if (users.length === 0) {
      return <p className="blocked-users__empty">{messages.noBlockedUsers}</p>;
    }
    return (
      <ul className="blocked-users__list">
        {users.map((user) => (
          <li key={user.id} className="blocked-users__item">
            <img
              src={user.profileImageUrl || "/images/profileImage.png"}
              alt={user.name}
              className="blocked-users__image"
              loading="lazy"
              decoding="async"
              width={56}
              height={56}
            />
            <div className="blocked-users__info">
              <p className="blocked-users__category">{user.category}</p>
              <p className="blocked-users__name">{user.name}</p>
            </div>
            <BlockButton
              targetUserId={user.id}
              userName={user.name}
              isBlocked={true}
              onUnblocked={handleUnblocked}
            />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <Header />
      <main className="blocked-users">
        <h1 className="blocked-users__title">ブロックしたユーザー</h1>
        {statusMessage && (
          <p className="blocked-users__status" role="status">
            {statusMessage}
          </p>
        )}
        {renderContent()}
      </main>
      <Footer />
    </>
  );
};

export default BlockedUsers;
